module.exports = {"610729001":"紫柏街道","610729101":"马道镇","610729102":"武关驿镇","610729103":"留侯镇","610729104":"江口镇","610729105":"玉皇庙镇","610729106":"火烧店镇","610729107":"青桥驿镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610729.json
// module id = 2857
// module chunks = 0